import ButtonAsAnchor from './ButtonAsAnchor';

export default ButtonAsAnchor;
